export default class SearchBar {
  constructor() {
    this.searchbar = $('[data-searchbar]');
    this.buttonSelector = '[data-searchbar].searchbar--inactive';
    this.menuSelector = '[data-searchbar-menu]';
    this.inputSelector = '[data-searchbar-input]';
    this.closeSelector = '[data-searchbar-close]';
  }

  aboveMobile() {
    return window.innerWidth > 960;
  }

  bind() {
    $(document).on('click', this.buttonSelector, this.open.bind(this));
    $(document).on('click', this.closeSelector, this.close.bind(this));
  }

  close() {
    this.toggleSearch();
    this.toggleMenu();
    this.searchbar.addClass('searchbar--inactive');
  }

  create() {
    this.bind();
  }

  focus() {
    $(this.inputSelector).focus();
  }

  open() {
    this.toggleSearch();
    this.toggleMenu();
    this.focus();
    this.searchbar.removeClass('searchbar--inactive');
  }

  toggleMenu() {
    if (this.aboveMobile()) {
      $(this.menuSelector).fadeToggle(200);
    }
  }

  toggleSearch() {
    this.searchbar.toggleClass('searchbar--active');
  }
}
